import { makeStyles } from '@material-ui/core'

import { pattern2 } from '../../images'

export default makeStyles((theme) => ({
  root: {
    backgroundColor: 'white'
  },
  section: {

  }
}))